import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { CqQasService } from '../../../../../common/services/CqQas.service';
import * as _ from 'lodash';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'cq-qas',
  templateUrl: './cq_qas.component.html',
  styleUrls: ['./cq_qas.css'],
  providers: [CqQasService, BsModalService],
})
@Injectable()
export class CqQasComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public model: any = {};
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public types: any = [];
  totalItem: any = 0;
  totalPage: any = 0;
  public modelFilter: any = {};

  public id_delete: number;
  public user: any = {};
  public data_options = [];
  public data_options_copy = [];
  public data_options_ans = [];
  public data_options_ans_copy = [];

  constructor(
    private cq_qasService: CqQasService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.loadData();
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.cq_qasService
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            console.log(res, '----is res');
            this.list = res.data.list;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
            // this.genDataTable();
            this.scrollToTop();
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );
  }

  search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      this.loadData({ name: this.modelFilter.keyword });
    } else {
      this.loadData();
    }
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  openModal(template: TemplateRef<any>, id?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);

    this.model = {};
    this.typeModal = id ? 'edit' : 'add';

    if (id) {
      this.cq_qasService
        .find(id)
        .toPromise()
        .then(rs => {
          console.log(rs);
          this.model = {
            qas_id: rs.data._id,
            name: rs.data.name,
          };

          this.data_options = rs.data.pattern;
          this.data_options_copy = Object.assign([], this.data_options);
        });
    } else {
      this.data_options = [];
      this.data_options_copy = [];
    }
  }

  add() {
    if (!this.model.name) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên chủ đề không được bỏ trống !',
      };
    } else {
      const data = [];
      let check = true;
      if (this.data_options_copy.length != 0) {
        for (let i = 0; i < this.data_options_copy.length; i++) {
          let check_ans = true;
          $('#opt-question' + i).css('border-color', '');
          if (
            !this.data_options[i].question ||
            (this.data_options[i].question && this.data_options[i].question.trim() == '')
          ) {
            $('#opt-question-' + i).css('border-color', 'red');
            check = false;
          } else {
            for (let j = 0; j < this.data_options_copy[i].data_options_ans_copy.length; j++) {
              const ans = this.data_options[i].data_options_ans[j];
              $('#opt-ans-' + i + '-' + j).css('border-color', '');
              if (!ans || (ans && ans.trim() == '')) {
                $('#opt-ans-' + i + '-' + j).css('border-color', 'red');
                check_ans = false;
              }
            }
            if (check_ans) {
              data.push(this.data_options[i]);
            } else {
              check = false;
            }
          }
        }
      }
      if (!check) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Câu hỏi hoặc câu trả lời không được bỏ trống !',
        };
        setTimeout(() => (this.message = null), 3000);
      } else {
        // this.model.data = _.map(data, e => {
        //     if(e.info && e.info.trim() != '') return e;
        // })
        for (let i = 0; i < data.length; i++) {
          delete data[i].data_options_ans_copy;
        }
        this.model.data = data;
        this.cq_qasService.create(this.model).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Thêm mới không thành công',
                };
                this.toastr.error('Thêm mới thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Thêm mới thành công',
                };
                this.toastr.success('Thêm mới thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });

                this.loadData();
                this.modalRef.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    }
  }

  edit(data) {
    this.message = null;
    if (!this.model.name) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên chủ đề không được bỏ trống !',
      };
    } else {
      const payload = {};
      if (this.model.name) {
        payload['name'] = this.model.name;
      }
      const data = [];
      const check = true;

      if (!check) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Câu hỏi hoặc câu trả lời không được bỏ trống !',
        };
        setTimeout(() => (this.message = null), 3000);
      } else {
        for (let i = 0; i < data.length; i++) {
          delete data[i].data_options_ans_copy;
        }
        this.cq_qasService.update(this.model.qas_id, payload).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Cập nhật không thành công',
                };
                this.toastr.error('Cập nhật thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Cập nhật thành công',
                };
                this.toastr.success('Cập nhật thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
                this.loadData();
                this.modalRef.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    }
    this.scrollToTop();
  }

  public changeType(e: any): void {
    this.model.type = e.value;
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    this.cq_qasService._delete(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa không thành công', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            // this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        this.toastr.error('Xóa không thành công', error.message, {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        // this.modalRef2.hide();
      }
    );
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  deleteOption(i) {
    this.data_options_copy.splice(i, 1);
    this.data_options.splice(i, 1);
  }

  addOption() {
    this.data_options_copy.push({
      question: '',
      data_options_ans_copy: [''],
      data_options_ans: [''],
    });
    this.data_options.push({
      question: '',
      data_options_ans_copy: [''],
      data_options_ans: [''],
    });
  }

  addOptionAns(i) {
    this.data_options_copy[i].data_options_ans_copy.push('');
    this.data_options_copy[i].data_options_ans.push('');
    this.data_options[i].data_options_ans_copy.push('');
    this.data_options[i].data_options_ans.push('');
  }

  deleteOptionAns(i, j) {
    this.data_options_copy[i].data_options_ans_copy.splice(j, 1);
    this.data_options_copy[i].data_options_ans.splice(j, 1);
    this.data_options[i].data_options_ans_copy.splice(j, 1);
    this.data_options[i].data_options_ans.splice(j, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/cq_qas/cq_qas.component.ts